const injectHTMLContent = (htmlString: string): void => {
  const target = document.getElementById('campaign-target')
  target?.insertAdjacentHTML('beforeend', htmlString)
  const scripts = target?.getElementsByTagName('script')
  while (scripts?.length) {
    const script = scripts[0]
    script.parentNode?.removeChild(script)
    const newScript = document.createElement('script')
    if (script.src) {
      newScript.src = script.src
    } else if (script.textContent) {
      newScript.textContent = script.textContent
    } else if (script.innerText) {
      newScript.innerText = script.innerText
    }
    document.body.appendChild(newScript)
  }
}

export default injectHTMLContent
